import { render } from "./GroupSettings.vue?vue&type=template&id=e3de5052&scoped=true"
import script from "./GroupSettings.vue?vue&type=script&lang=js"
export * from "./GroupSettings.vue?vue&type=script&lang=js"

import "./GroupSettings.vue?vue&type=style&index=0&id=e3de5052&scoped=true&lang=css"
import "./GroupSettings.vue?vue&type=style&index=1&id=e3de5052&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3de5052"]])

export default __exports__